import { useMemo } from 'react';

import { CheckCircle, Close, Reply } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { toast } from 'react-toastify';

type ShareButtonProps = {
  market?: string;
  section?: string;
  size?: number;
};

export function ShareButton({ market, section, size }: ShareButtonProps) {
  const url = useMemo(() => {
    if (!market || !section) {
      return window.location.href;
    }
    const host = process.env.REACT_APP_PUBLIC_URL ?? window.location.origin;
    return `${host}/anuarios/2026/${market}/${section}`;
  }, [market, section]);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(url);
      toast('Link copiado!', {
        autoClose: 1000,
        type: 'success',
        icon: <CheckCircle color="secondary" sx={{ p: 0.25 }} />,
        closeButton: <Close fontSize="small" sx={{ color: 'white' }} />,
        progressStyle: {
          backgroundColor: '#FF8211',
        },
        style: {
          backgroundColor: 'rgba(14, 15, 14, 0.5)',
          color: 'white',
          fontFamily: 'Figtree',
          borderRadius: '12px',
          border: '1px solid #FF8211',
          backdropFilter: 'blur(6px)',
        },
      });
    } catch (_) {
      toast.error('Nao foi possivel copiar o link.');
    }
  }

  async function handleShare() {
    const shareData: ShareData = {
      title: 'UQBAR - Anuário 2026',
      text: 'Confira o anuário 2026',
      url,
    };

    if (typeof navigator.share !== 'function') {
      await handleCopy();
      return;
    }

    if (typeof navigator.canShare === 'function') {
      try {
        if (!navigator.canShare(shareData)) {
          await handleCopy();
          return;
        }
      } catch (_) {
        await handleCopy();
        return;
      }
    }

    try {
      await navigator.share(shareData);
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return;
      }

      await handleCopy();
    }
  }

  return (
    <IconButton
      onClick={handleShare}
      size="small"
      sx={{
        transform: 'scaleX(-1)',
        backgroundColor: 'primary.main',
        '&:hover': {
          backgroundColor: 'primary.main',
        },
      }}>
      <Reply
        sx={{
          color: 'white',
          width: size ?? 32,
          height: size ?? 32,
          pb: 0.5,
        }}
      />
    </IconButton>
  );
}
